import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_CIC_ALERT_COUNTS_REQUEST = 'GET_CIC_ALERT_COUNTS_REQUEST';
export const GET_CIC_ALERT_COUNTS_SUCCESS = 'GET_CIC_ALERT_COUNTS_SUCCESS';
export const GET_CIC_ALERT_COUNTS_FAILURE = 'GET_CIC_ALERT_COUNTS_FAILURE';

function requestGetCicAlertCounts() {
  return {
    type: GET_CIC_ALERT_COUNTS_REQUEST,
    isCicAlertCountsLoading: true
  };
}

function receiveGetCicAlertCounts(cicAlertsAssignedCount, cicAlertsUnassignedCount) {
  return {
    type: GET_CIC_ALERT_COUNTS_SUCCESS,
    isCicAlertCountsLoading: false,
    cicAlertsAssignedCount,
    cicAlertsListError: null,
    cicAlertsUnassignedCount
  };
}

function rejectGetCicAlertCounts(cicAlertsCountsError) {
  return {
    type: GET_CIC_ALERT_COUNTS_FAILURE,
    isCicAlertCountsLoading: false,
    cicAlertsCountsError
  };
}

export function getCicAlertCounts() {
  return (dispatch) => {
    dispatch(requestGetCicAlertCounts());

    const promise = () => ApiService
      .getCicAlertCounts()
      .then((response) => {
        dispatch(receiveGetCicAlertCounts(response.data.assignedCount, response.data.unassignedCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetCicAlertCounts, true));
        }
      });
    return promise();
  };
}
